import React from "react";
import Grid from "@mui/material/Grid";

const GridContainer = ({ children, direction }) => (
    <Grid container direction={direction} sx={{ paddingLeft: 5, paddingRight: 5 }}>
        {children}
    </Grid>
);

export default GridContainer;